import { render, staticRenderFns } from "./vIcon.vue?vue&type=template&id=4f40bec6&scoped=true&"
import script from "./vIcon.vue?vue&type=script&lang=js&"
export * from "./vIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f40bec6",
  null
  
)

export default component.exports